export default "__VITE_ASSET__C5Q66hA6__"